// extracted by mini-css-extract-plugin
export default {"shortlisted_component":"ShortlistedComponent_shortlisted_component__5riv-"};